import React, { createContext, useContext } from 'react';
import { useAuthStore, apiClient, API_ENDPOINTS } from '@dukene/shared';
import { useQuery } from '@tanstack/react-query';
import { confirmAction } from '../components/modals/ConfirmModal';

interface AuthContextType {
  user: any;
  activeStore: any;
  activeStoreId?: string | null;
  lockSystem: () => void;
}

const AuthContext = createContext<AuthContextType>({
  user: null,
  activeStore: null,
  activeStoreId: null,
  lockSystem: () => {},
});

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, activeStoreId, logout } = useAuthStore();

  const { data: store } = useQuery<any>({
    queryKey: ['merchant-store', activeStoreId],
    queryFn: async () => apiClient.get<any>(API_ENDPOINTS.MERCHANT.STORE),
    enabled: !!activeStoreId,
  });

  const adaptedUser = user ? {
    ...user,
    role: user.role || 'tenant_owner',
    stores: store ? [{ id: store.id, name: store.name, vat_config: store.settings?.vatConfig }] : [],
    access: {
      posPermissions: {
        canApplyDiscount: true,
        canOverridePrice: true,
        canManageOrders: true,
      },
    },
  } : null;

  return (
    <AuthContext.Provider
      value={{
        user: adaptedUser,
        activeStore: store || null,
        activeStoreId: activeStoreId || store?.id || null,
        lockSystem: async () => {
          const confirmed = await confirmAction({
            title: 'Lock Register Screen',
            message: 'Are you sure you want to lock the register screen?',
            confirmText: 'Lock Register',
            cancelText: 'Cancel',
          });
          if (confirmed) {
            logout();
          }
        },
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
